import { saleExpired } from '@libs/core';

import type { Price } from '../model/types';

export type OneTimePrice = {
    effectivePrice: number;
    regularPrice: number;
    isOnSale: boolean;
};

export const getOneTimePrice = (price: Price): OneTimePrice => {
    const { original, sale, saleValidUntil } = price;

    const eligibleSale = typeof sale === 'number' && !saleExpired(saleValidUntil ?? null) ? sale : null;

    return {
        effectivePrice: eligibleSale ?? original,
        regularPrice: original,
        isOnSale: eligibleSale !== null,
    };
};
